import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-notes-modal',
  templateUrl: './notes-modal.component.html',
  styleUrls: ['./notes-modal.component.scss']
})
export class NotesModalComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<NotesModalComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { notes: string }) {
  }

  ngOnInit(): void {

  }

}
